import { Layout } from "gatsby-plugin-image";
import { SbImageMetadata } from "./getSbImageMetadata.util";

interface SbGatsbyImageOutputDimensions {
    outputWidth: number;
    outputHeight: number;
}

export const getSbGatsbyImageOutputDimensions = (layout: Layout, width: number, height: number, aspectRatio: number, metadata: SbImageMetadata): SbGatsbyImageOutputDimensions => {
    switch (true) {
        case layout === 'fullWidth':
            return { outputWidth: aspectRatio, outputHeight: 1 };
        case Boolean(width && height):
            return { outputWidth: width, outputHeight: height };
        case Boolean(width && !height):
            return { outputWidth: width, outputHeight: Math.round(width / aspectRatio) };
        case Boolean(!width && height):
            return { outputWidth: Math.round(height * aspectRatio), outputHeight: height };
        case Boolean(!width && !height):
        default:
            return { outputWidth: metadata.width, outputHeight: metadata.height }
    }
}